import React from "react";
import {Progress, Tooltip} from "antd";
import styles from "../components/index.module.scss";

export default class UploadItemLayout extends React.Component {
    render() {
        const {file, onRemove, onDownload, cancelUpload, showInsertion} = this.props;
        const data = file || {};
        const speed = file.originFileObj && file.originFileObj.speed ? file.originFileObj.speed : null;
        let attachmentWidth = this.props.fieldProps.col === 12 ? 230 : 605;
        let showDeleteBtn = true;
        if(this.props.fieldProps.isUpdateInfo === false) {
            attachmentWidth = this.props.fieldProps.col === 12 ? 120 : 400;
            showDeleteBtn = false;
        }
        return <div className={styles.uploadItem}>
            <div className={styles.itemProcess}>
                <div
                    className={styles.itemName}
                    title={data.name}
                    style={((!data?.url) || (data?.status !== "error" && !data?.url && data?.percent < 100)) ? {maxWidth: this.props.fieldProps.col === 12 ? 100 : "40%"} : {
                        maxWidth: attachmentWidth,
                        marginRight: 10
                    }}
                >{data.name}</div>
                <Progress
                    style={
                        ((!data?.url) || (data?.status !== "error" && !data?.url && data?.percent < 100))
                            ? {
                                width: this.props.fieldProps.col === 12 ? 160 : "40%",
                                margin: "0 10px"
                            }
                            : {display: "none"}
                    }
                    percent={Number(data?.percent ? data.percent : 0)}
                    format={(percent) => {
                        if (data?.originFileObj?.cancelUpload === true) {
                            return "已取消"
                        }
                        if (data?.status === "error") {
                            return (
                                <Tooltip title={file?.originFileObj?.uploadStatus || "上传失败"}>
                                    <div style={{
                                        width: 56,
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                        whiteSpace: "nowrap"
                                    }}>{file?.originFileObj?.uploadStatus || "上传失败"}</div>
                                </Tooltip>
                            )
                        }
                        if (percent >= 100 && file?.originFileObj?.uploadStatus) {
                            return <div>{file?.originFileObj.uploadStatus}</div>
                        }
                        return `${percent}% ${speed ? "/  " + speed : ""}`
                    }}
                    status={!data?.url ? (data?.status === "error" ? "exception" : "active") : "success"} size="small"
                />
            </div>
            <div className={styles.itemButtonContent} style={{color: window.themeBgColor}}>
                {
                    data?.url ? (
                        <>
                            {showInsertion(file)}
                            <div onClick={() => {
                                onDownload(file)
                            }}>下载
                            </div>
                            {showDeleteBtn ?
                                <div onClick={() => {
                                    onRemove(file)
                                }}>删除
                                </div> : null}
                        </>
                    ) : ""
                }
                {
                    (data?.status === "error" || data?.originFileObj?.cancelUpload === true) ? (
                        <>
                            <div onClick={() => {
                                onRemove(file)
                            }}>删除
                            </div>
                        </>
                    ) : ""
                }
                {
                    !data?.url && data?.status !== "error" && data?.originFileObj?.cancelUpload !== true ? (
                        <>
                            <div onClick={() => {
                                cancelUpload(file)
                            }}>取消上传
                            </div>
                        </>
                    ) : ""
                }
            </div>
        </div>
    }
}